import intl from 'react-intl-universal';
import OtpInput from 'react-otp-input';
import { Button, Col, FormGroup, Label, Row } from 'reactstrap';

import styles from './mfaBackupForm.module.scss';
import MfaBackupFormProps from './MfaBackupFormProps';

const MfaBackupCodeForm: React.FC<MfaBackupFormProps> = (
  props: MfaBackupFormProps
) => {
  const { backupCode, onBack, onBackupCodeVerification, onBackupCodeChange } =
    props;

  return (
    <>
      <p className="text-16-bold">
        {intl.get('LBL_MFA_BACKUP_CODE_SUB_TITLE')}
      </p>
      <p className="text-14-light mb-4">
        {intl.get('LBL_MFA_BACKUP_CODE_DESCRIPTION')}
      </p>
      <FormGroup>
        <Label>{intl.get('LBL_MFA_BACKUP_CODE_INPUT_LABEL')}</Label>
        <OtpInput
          value={backupCode}
          onChange={onBackupCodeChange}
          numInputs={8}
          // Set inputType to tel to avoid arrow buttons
          inputType="text"
          containerStyle={styles.otpContainer}
          inputStyle={styles.backupInput}
          shouldAutoFocus
          // eslint-disable-next-line react/jsx-props-no-spreading
          renderInput={(inputProps) => <input {...inputProps} />}
        />
      </FormGroup>

      <Row>
        <Col>
          <Button
            size="lg"
            color="secondary"
            className="w-100 justify-content-center mt-4 mb-5"
            onClick={onBack}
          >
            {intl.get('BTN_BACK')}
          </Button>
        </Col>
        <Col>
          <Button
            size="lg"
            color="primary"
            onClick={onBackupCodeVerification}
            className="w-100 justify-content-center mt-4 mb-5"
          >
            {intl.get('BTN_AUTHENTICATE')}
          </Button>
        </Col>
      </Row>

      <Row>
        <Col className="text-14-medium text-center">
          {intl.get('LBL_MFA_BACKUP_CODE_FOOTER_LABEL')}
        </Col>
      </Row>
      <Row>
        <Col className="text-center">
          <a
            href="https://support.dreamstartlabs.com/"
            rel="noopener noreferrer"
            target="_blank"
            className="text-14-light text-secondary-dark"
          >
            {intl.get('LBL_MFA_BACKUP_CODE_FOOTER_LINK')}
          </a>
        </Col>
      </Row>
    </>
  );
};

export default MfaBackupCodeForm;
